<template>
    <div>
        <app-header :title="showModal?'Zeitraum wählen':'Meine Trends'" :close="showModal?'true':'false'" @close="showModal = false"></app-header>
        <div class="page">

            <form >
                <button type="button" id="show-alle-release" @click="showAlleRelease = true">Alle Releases</button>
                <button type="button" id="show-modal" @click="showModal = true" class="active">letzte 30
                    Tage</button>

                <router-link :to="{name: 'filter_wahlen'}" tag="button">Filter</router-link>
            </form>
            <modal v-if="showModal" @close="showModal = false">

            </modal>

            <alle-release v-if="showAlleRelease" @close="showAlleRelease = false">

            </alle-release>
            <feed-back v-if="feedBackPage=='true'" @close="feedBackPage = false">

            </feed-back>
            <div class="chart_with_description">
                <div class="row">
                    <div class="col">
                        <h1>Einnahmen</h1>
                        <h3>Total</h3>
                    </div>
                    <div class="col">
                        <h1>CHF 1295.30</h1>
                        <span>+ CHF 195.40</span>
                    </div>
                </div>
                <chart class="chart"></chart>
            </div>
            <div class="table">
                <app-item v-for="item in items" :item="item"></app-item>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '../Header';
    import Chart from '../chart/LineChart';
    import Item from './Item';
    import Footer from '../Footer_menu'
    import DatePick from 'vue-date-pick';
    import Modal from './CalendarView';
    import AlleRelease from './Alle_release';
    import FeedBack from './Feed_back';
    export default {
        props: ['feedBackPage'],
        data: () => ({
            date: '2019-01-01',
            showModal: false,
            showAlleRelease: false


        }),
        computed: {
            items() {
                return this.$store.getters.Meine_trends;
            }
        },
        components: {
            appHeader: Header,
            Chart,
            appItem: Item,
            appFooter: Footer,
            DatePick,
            modal: Modal,
            alleRelease: AlleRelease,
            feedBack: FeedBack
        },
        created()  {
            this.feedBackPage=this.$route.params.feedBackPage;
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/style';

    .page {
        padding-top: 60px;
        overflow: hidden;
        color: #252226;

        form {
            margin: 14px 20px;
            text-align: left;

            button {
                background-color: $button_full_color;
                padding: 6px 13px;
                color: #4A4A4A;
                font-size: 1.2rem;
                font-weight: 700;
                border: 1px solid $o-circle_color;
                border-radius: 4px;
                margin: 1px;
                letter-spacing: -0, 2181818px;
            }

            .active {
                background-color: $button_full_backGroundColor;
                color: $button_full_color;
            }

        }

        .chart_with_description {
            overflow: hidden;
            -webkit-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.3);
            -moz-box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.3);
            box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.3);
            position: relative;
            height: 182px;
            width: 335px;
            margin: 22px auto;

            .row .col {
                z-index: 2;

                h1 {
                    font-family: "SF UI Text Light";
                    font-size: 2.0rem;
                    font-weight: 500;
                    letter-spacing: -0, 2px;
                    line-height: 28px;
                    color: $font-color_dark;
                    margin-top: 15px;
                    margin-left: 15px;
                    margin-bottom: 0px;
                }

                h3 {
                    font-size: 1.4rem;
                    margin-left: 15px;
                    color: $label-color;
                }

                span {
                    font-size: 1.4rem;
                    text-align: right;
                    display: block;
                    margin-right: 18px;
                    color: $success;

                }
            }

            .chart {
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
            }
        }

        .table{
            border-top:1px solid $line_color;
            width:90%;
            margin:2px auto;
        }
    }






</style>



// WEBPACK FOOTER //
// src/components/meine_trends/Meine_trends.vue